'use client';

import { ReactNode } from 'react';
import GlobalErrorHandler from '@/components/error/GlobalErrorHandler';
import ErrorBoundary from '@/components/error/ErrorBoundary';

interface ErrorLoggerProviderProps {
  children: ReactNode;
}

/**
 * Error Logger Provider
 * 
 * Wraps the app with global error handling and error boundaries.
 * Add this to your root layout.
 */
export default function ErrorLoggerProvider({ children }: ErrorLoggerProviderProps) {
  return (
    <>
      <GlobalErrorHandler />
      <ErrorBoundary componentName="App">
        {children}
      </ErrorBoundary>
    </>
  );
}
